<div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--bar-chart-tooltip-header">
    <div class= "page--building-level-real-estate-transactions-page--market-data-overview-desktop--bar-chart-tooltip-header-title">
        <%= I18n.t("apps_spacious_website_pages.building_level_real_estate_transaction_list_page.sections.overview.graph.transaction_volume") %>
    </div>
    <div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--bar-chart-tooltip-header-percentage-different <%= extra_class %>">
        <%= percentage_label %>
    </div>
</div>
